export const ProjectData = [
  {
    name: "Food Fusion web",
    description:"This is a food fusion web apps to solve your food hunger problem",
    url: "https://6675cfda076d6ed890666700--gentle-belekoy-91034d.netlify.app/",
    img: "https://img.freepik.com/premium-vector/indian-restaurant-icon-spice-food-bowl-chilli_8071-6781.jpg?semt=ais_hybrid",
  },
  {
     name:"Tic Tac toe ",
     description:"This is a Tic Tac toe a game website where any body can play",
     url:"https://rjtictactoegamedemo.surge.sh/",
     img:"https://cdn-icons-png.flaticon.com/512/8002/8002181.png"

  },
  {
    name:"You tube",
    description:"This is a youtube frontend Ui part made with react js and youtube",
    url:"https://66772f9070b58fdfd89eb391--startling-sawine-7f7008.netlify.app/",
    img:"https://img.freepik.com/free-vector/youtube-concept_23-2147862172.jpg?w=360",

  },
  {
    name:"School Website",
    description:"This is a School website project which i just made in 1 day with all functionaloty to intearactive ui",
    url:"https://66a226bd9bcf5cf39750a283--endearing-selkie-c9df51.netlify.app",
    img:"https://img.freepik.com/free-vector/gradient-high-school-logo-design_23-2149626932.jpg",

  },
  
];
